import { action } from "mobx";
import { MrbBaseViewStore } from "mrb/core";
import { MrbSelectStore } from "mrb/components/select";
import { isNil } from "lodash";

class EditNakiStoreFeaturedSectionContentViewStore extends MrbBaseViewStore {
    item = {};
    onUpdate = null;
    shouldAdd = false;
    addItem = null;

    constructor(rootStore, { routeStore, item, onUpdate, shouldAdd, addItem }) {
        super(rootStore);
        this.routeStore = routeStore;
        this.item = item || {};
        this.onUpdate = onUpdate;
        this.shouldAdd = shouldAdd;
        this.addItem = addItem;

        this.contentSelectStore = new MrbSelectStore({
            isSearchable: true,
            textKey: "title",
            valueKey: "id",
            initFetch: false,
            actions: {
                find: (searchTerm, pageNumber, pageSize) => {
                    return this.routeStore.getContent({
                        search: searchTerm,
                        pageNumber: pageNumber,
                        pageSize: pageSize,
                    });
                },
                mapItem: (item) => {
                    return {
                        label: item.title,
                        value: item.podcastId || item.nakiNigunArtistId || item.nakiNigunAlbumId,
                        item: item,
                    };
                },
            },
        });
        this.onSelectItem = this.onSelectItem.bind(this);
    }

    @action.bound
    onSelectItem() {
        const item = this.contentSelectStore.selectedItem;

        this.updateItem(item);
        this.contentSelectStore.clearOptions();
        this.contentSelectStore.clear();
        this.contentSelectStore.filter();
    }

    @action.bound
    updateItem(item) {
        this.item.podcastId = null;
        this.item.podcast = null;
        this.item.nakiNigunArtistId = null;
        this.item.nakiNigunArtist = null;
        this.item.nakiNigunAlbumId = null;
        this.item.nakiNigunAlbum = null;
        if (!isNil(item.podcastId)) {
            this.item.podcastId = item.podcastId;
            this.item.podcast = {
                id: item.podcastId,
                title: item.title,
                isPremium: item.isPremium,
                coverImageId: item.coverImageId,
                podcastType: item.podcastType,
            };
        } else if (!isNil(item.nakiNigunArtistId)) {
            this.item.nakiNigunArtistId = item.nakiNigunArtistId;
            this.item.nakiNigunArtist = {
                id: item.nakiNigunArtistId,
                name: item.title,
                isPremium: item.isPremium,
                coverImageId: item.coverImageId,
            };
        } else if (!isNil(item.nakiNigunAlbumId)) {
            this.item.nakiNigunAlbumId = item.nakiNigunAlbumId;
            this.item.nakiNigunAlbum = {
                id: item.nakiNigunAlbumId,
                title: item.title,
                isPremium: item.isPremium,
                coverImageId: item.coverImageId,
            };
        }

        if (this.shouldAdd) {
            this.addItem(this.item);
        }

        this.onUpdate();
    }
}

export default EditNakiStoreFeaturedSectionContentViewStore;
